import { render } from "./OpportunityDetail.vue?vue&type=template&id=603df166&scoped=true"
import script from "./OpportunityDetail.vue?vue&type=script&lang=js"
export * from "./OpportunityDetail.vue?vue&type=script&lang=js"

import "./OpportunityDetail.vue?vue&type=style&index=0&id=603df166&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-603df166"]])

export default __exports__